function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M0,0v24h24V0H0z M4.7,15.5C4.3,15.2,4,14.6,4,14s0.3-1.1,0.7-1.5V15.5z M6,16c-0.2,0-0.4,0-0.7-0.1v-3.8 C5.6,12,5.8,12,6,12V16z M7.3,16H6.7v-3.8l0.2,0.1c0.1-0.4,0.3-0.7,0.5-1L7.3,16L7.3,16z M8.7,16H8v-5.4c0.2-0.2,0.4-0.3,0.7-0.4V16 z M10,16H9.3v-5.9c0.3,0,0.3,0,0.7,0V16z M11.3,16h-0.7v-5.7l0.3,0.1c0.1-0.2,0.3-0.4,0.4-0.6V16z M18.1,16H12V9.3 c0.5-0.4,1.2-0.6,1.8-0.6c1.8,0,3.3,1.5,3.4,3.4c1.3-0.6,2.7,0.4,2.7,1.9C20,15.1,19.1,16,18.1,16z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      "enableBackground": "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/soundcloud.45e4b90c.svg";
export { SvgComponent as ReactComponent };